import apiClient from "../api/apiClient";
import { BlogPost, BlogFormData, BlogApiResponse, BlogFilters } from "../types/blog";

export class BlogService {

  static async getBlogPosts(filters: BlogFilters): Promise<BlogApiResponse> {
    const queryParams = new URLSearchParams();

    queryParams.append("postType", "ARTICLE");
    
    if (filters.published === "true") queryParams.append("published", "true");
    if (filters.published === "false") queryParams.append("published", "false");
    if (filters.search) queryParams.append("search", filters.search);
    queryParams.append("page", filters.page?.toString() || "1");
    queryParams.append("limit", filters.limit?.toString() || "10");

    const response = await apiClient.get(
      `/community/posts?${queryParams.toString()}`
    );
    return response.data;
  }

  static async getBlogPost(slug: string): Promise<{ status: boolean; data: BlogPost }> {
    const response = await apiClient.get(`/community/posts/${slug}`);
    return response.data;
  }

  static async createBlogPost(
    blogData: BlogFormData
  ): Promise<{ status: boolean; data: BlogPost; message: string }> {
    const response = await apiClient.post("/community/posts", {
      ...blogData,
      postType: "ARTICLE",
    });
    return response.data;
  }

  static async updateBlogPost(
    id: string,
    blogData: Partial<BlogFormData>
  ): Promise<{ status: boolean; data: BlogPost; message: string }> {
    const response = await apiClient.put(`/community/posts/${id}`, blogData);
    return response.data;
  }

  static async deleteBlogPost(id: string): Promise<{ status: boolean; message: string }> {
    const response = await apiClient.delete(`/community/posts/${id}`);
    return response.data;
  }

  static async updateBlogStatus(
    id: string,
    published: boolean
  ): Promise<{ status: boolean; message: string }> {
    const response = await apiClient.put(`/community/posts/${id}/publish`, { published });
    return response.data;
  }

  static async updateBlogFeatured(
    id: string,
    featured: boolean
  ): Promise<{ status: boolean; message: string }> {
    const response = await apiClient.put(`/community/posts/${id}`, { featured });
    return response.data;
  }

  static async uploadFeaturedImage(
    imageFile: File
  ): Promise<{ status: boolean; imageUrl: string; message: string }> {
    const formData = new FormData();
    formData.append("media", imageFile);

    const response = await apiClient.post(
      "/community/post/upload-media",
      formData,
      { headers: { "Content-Type": "multipart/form-data" } }
    );

    return {
      status: response.data.status,
      imageUrl: response.data.mediaUrl,
      message: response.data.message || "",
    };
  }

  static async getFeaturedBlogPosts(limit = 3): Promise<BlogApiResponse> {
    const response = await apiClient.get(
      `/community/posts?postType=ARTICLE&published=true&limit=${limit}&featured=true`
    );
    return response.data;
  }

  static async getBlogCategories(): Promise<{ status: boolean; data: string[] }> {
    return { status: true, data: [] };
  }
}

export default BlogService;